/** @format */

// export const routes = [
export const routes = [
    //
    {
        path: "/",
        name: "login",
        component: () => import("@/views/user/login.vue"),
    },
    {
        path: "/reg",
        name: "register",
        component: () => import("@/views/user/register.vue"),
    },
    {
        path: "/forget",
        redirect: "/",
    },
    {
        // 布局
        path: "/layout",
        name: "layout",
        component: () => import("@/views/layout.vue"),
        redirect: "/home",
        children: [
            //首页
            {
                path: "/home",
                name: "home",
                component: () => import("@/views/home.vue"),
                meta: {
                    title: "Home",
                    mes: "Welcome to VDC platform",
                },
            },
            
            // 智能体
            {
                path: "/taskPlaza",
                name: "taskPlaza",
                component: () => import("@/views/intelligentAgent/taskPlaza.vue"),
                meta: {
                    title: "任务广场",
                },
            },

            // 创建课程
            {
                path: "/courseDesign",
                name: "courseDesign",
                component: () => import("@/views/courseDesign/index.vue"),
                meta: {
                    title: "创建课程",
                    mes: "财务智能体课程设计",
                },
            },
            // 我的课程
            {
                path: "/myCourses",
                name: "myCourses",
                component: () => import("@/views/myCourses/index.vue"),
                meta: {
                    title: "我的课程",
                },
            },
            
        ],
    },



    /*{
      //常用写法,通过正则表达式,如果路由不匹配去这个404组件
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('../view/home/Home.jsx')
    },*/
    
];
